import DropdownCheckbox from "components/DropdownCheckbox";
import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import {
  BPEStore,
  Option,
} from "features/BuildingProductEditor/ProductEditorStore";

export default observer(function EPDTypeFilter({
  selected,
  setSelected,
  removingItem,
  handleRemoveItem,
}: {
  selected?: Option[];
  setSelected: React.Dispatch<React.SetStateAction<Option[]>>;
  removingItem: Option | undefined;
  handleRemoveItem: () => void;
}) {
  const { t } = useTranslation();

  React.useEffect(() => {
    (async () => {
      await BPEStore.fetchEPDtypes();
    })();
  }, []);

  const onChangeCategories = (value: Option[]) => setSelected(value);

  if (!BPEStore.filtersOptions.epd_type) return <></>;
  return (
    <DropdownCheckbox<Option>
      displayKey={"name"}
      required={true}
      handleSelect={onChangeCategories}
      labelName={t("mapping.epdType")}
      name="epdType"
      items={BPEStore.filtersOptions.epd_type}
      removeSelected={removingItem}
      handleRemoveSelected={handleRemoveItem}
      containerClassName="mr-0 sm:mr-3 min-w-[200px] !mb-3"
      optionsClassName="z-40 !max-w-fit"
      checkedItems={selected}
    />
  );
});
